export const CENTERS_TYPES = [];

export const FILTERS = [
  {
    value: 'only',
    label: 'Centres avec RDV disponibles en ligne',
  },
  {
    value: 'without-appointment',
    label: 'Centres avec plages sans RDV',
  },
  {
    value: 'vac-5-11',
    label: 'Centres vaccinant les 5-11 ans',
  },
];
